// 1. Import fungsi spesifik dari sub-path untuk versi 9 (Modular SDK)
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getDatabase } from "firebase/database";
// Catatan: Tidak perlu 'import firebase from "firebase";' lagi

// 2. Objek Konfigurasi (Menggunakan data dari tangkapan layar Anda)
const firebaseConfig = {
  apiKey: "AIzaSyD1rR2871yVB7vUdKX4hvvwAd7xU8bcqxM",
  authDomain: "web-genesaret.firebaseapp.com",
  projectId: "web-genesaret",
  storageBucket: "web-genesaret.firebasestorage.app",
  messagingSenderId: "190120991200",
  appId: "1:190120991200:web:de8a738d6500075a8f3385",
};

// 3. Inisialisasi Aplikasi (Hanya Sekali)
const app = initializeApp(firebaseConfig);

// 4. Inisialisasi Layanan Utama dan Ekspor (Named Exports)
// Ini adalah objek yang akan Anda import di komponen React
export const auth = getAuth(app); // Untuk fitur login
export const db = getDatabase(app); // Untuk jadwal dan renungan
export const storage = getStorage(app); // Untuk upload PDF

// (Opsional) Ekspor objek app
export default app;
